import PropTypes from "prop-types";

import { FLYOUT_HEADER_CLASSES } from "./Flyout.styles";

const FlyoutHeader = ({ children = null }) => <div className={FLYOUT_HEADER_CLASSES}>{children}</div>;

FlyoutHeader.propTypes = {
  children: PropTypes.node,
};

export default FlyoutHeader;
